import { useContext, useEffect, useRef, useState } from "react";
import './Producto.scss';
import { Link, useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import { GlobalFunctionsContext } from "../../services/GlobalFunctionsContext";
import SliderComponent from "../SliderComponent";
import { ArrowLeft, Box, Clock } from "react-bootstrap-icons";
import { AuthContext } from "../../services/AuthContext";
import '../../assets/scss/Table.scss';
import { Percent, Tv } from "lucide-react";
import ButtonAddToCart from "./ButtonAddToCart";

export default function Producto({prod, onVisible, onMessage, onKeepShopping, cartSelected, setVariantAlert}) {
  const { user, isAuthenticated } = useContext(AuthContext);
  const { formatCurrency, convertStringToLink } = useContext(GlobalFunctionsContext);
  const [productData, setProductData] = useState({minimo_compra: 0, cantidad: 0, variaciones: []});
  const ref = useRef(null);
  const [scrolledPast, setScrolledPast] = useState(false);
  const [observations, setObservations] = useState('')
  const navigate = useNavigate()

  useEffect(()=>{
    let variations = [];
    const dto = user && !user.disc_visib ? user.discount : 0; //Si no es visible el dto del cliente se aplica al precio 
    prod.variaciones.map((item => {
      variations.push({
        id: item.id,
        nombre: item.nombre,
        precio: (item.precio ? item.precio : prod.precio) * (1-dto/100),
        cantidad: 0,
        subtotal: 0,
        inCart: item.inCart ? item.inCart : 0,
        descuento: item.descuento ? item.descuento : prod.descuento,
        stock: item.stock ? item.stock : -1
      })
    }))

    setProductData({
      id: prod.id,
      nombre: prod.nombre,
      alicuota: prod.alicuota ? prod.alicuota : 1.21,
      stock: prod.stock,
      precio: prod.precio * (1 - dto/100),
      descuento: prod.descuento ? prod.descuento : 0,
      cantidad: variations.length > 0
        ? 0
        : prod.minimo_compra
          ? prod.minimo_compra
          : 1,
      variaciones: variations,
      subtotal: variations.length > 0
        ? 0
        : prod.minimo_compra
            ? prod.minimo_compra * (prod.precio * (1-dto/100) * (1 - prod.descuento/100))
            : prod.precio * (1-dto/100) * (1 - prod.descuento/100)
        ,
      canAddtoCart: user
        ? cartSelected
          ? variations.length > 0
            ? !variations.every((variation) => variation.cantidad == 0)
            : prod.stock >= prod.minimo_compra
          : false
        : false,
      minimo_compra: prod.minimo_compra
        ? prod.minimo_compra != 0
          ? prod.minimo_compra
          : 1
        : 1,
      inCart: prod.inCart ? prod.inCart : 0,
      preview: prod.portada ? prod.portada + '_thumb.webp' : prod.media ? prod.media[0].imagen + '_thumb.webp' : null 
    })

    if (prod.observaciones) {
      setObservations(prod.observaciones)
    }
  },[prod]);

  useEffect(()=>{
    const handleScroll = () => {
      const triggerHeight = 500; // cambia este valor según el punto deseado
      const scrollY = window.scrollY;

      setScrolledPast(scrollY > triggerHeight);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);

  },[])

  const updateVarData = (variation) => {
    setProductData(prev => ({
      ...prev,
      variaciones:variation
    }))
  }

  const handleFocus = (i) => {
    let newVariations = [...productData.variaciones];
    newVariations[i].cantidad = ''
    updateVarData(newVariations)
  }

  const handleChange = (i, value) => {
    onVisible(false)
    let newVariations = [...productData.variaciones];

    newVariations[i].cantidad = value
    updateVarData(newVariations)
  }

  const handleBlur = (i, value) => {
    onVisible(false)
    let newVariations = [...productData.variaciones];
    const newStock = newVariations[i].stock ? newVariations[i].stock : -1;
    if (value === '') {
      newVariations[i].cantidad = 0
    } else {
      if (user.notAplyMin) {
        newVariations[i].cantidad = value
      } else {
        newVariations[i].cantidad = value
      }
    }
    updateVariation(newVariations,i)

    if ((newStock != -1) && (newStock < value)) {
      onMessage('¡No hay suficiente stock!');
      onVisible(true);
    }
  }

  const updateVariation = (variations, i) => {
    let total = 0;
    variations[i].subtotal = (variations[i].precio*(1-variations[i].descuento/100) * (1-user.discount/100)) * variations[i].cantidad
    variations.forEach(element => {
      total += element.subtotal
    });
    setProductData(prev => ({
      ...prev,
      subtotal: total,
      variaciones: variations
    }))
  }

  const handleDecrement = (i) => {
    const value = productData.variaciones[i].cantidad - 1;
    handleBlur(i,value)
  };

  const handleIncrement = (i) => {
    const value = productData.variaciones[i].cantidad + 1;
    handleBlur(i,value)
  }

  const handleKeepShopping = () => {
    onKeepShopping();
  }

  const totalChanged = (total) => {
    setProductData((prev) => ({
      ...prev,
      subtotal: total * prev.precio * (1-prev.descuento / 100)
    }))
  }

  const handleBuyNow = () => {
    navigate('/carrito')
  }

  const hundleUpdateProduct = (id, c) => {
    productData.inCart = c > 0
    productData.cantInCart = c
  }

  return (
    <div className="content-product" ref={ref}>
      <div className="left-box"
      >
        <div className={`sticky-image ${scrolledPast ? 'scrolling' : ''}`}>
          {prod.en_tv ?
            <div className="en_tv">
              <Tv /> En Tv
            </div>
            :null
          }
          {prod.fecha_dif < 60
          ? <div className="new">
              Novedad
            </div> 
          : null}
          {prod.descuento > 0
            ? <div className={`promo ${prod.en_tv ? 'down' : ''}`}>
                <Percent />
                Promo
              </div>
            : null}
          <SliderComponent images={prod.media} video={prod.video}></SliderComponent>
        </div>
      </div>
      <div className="right-box">
        <div className="header">
          <div className="breadcrumb">
            <Link to={`/`}>home</Link>
            {prod.categoryList.map((cat)=>{
              return (
                <span key={`cate_${cat.id}_a`} className="arrow">{' > '}
                  <Link key={`cate_${cat.id}_b`} to={`/categoria/${cat.id}-${convertStringToLink(cat.nombre)}`}>{cat.nombre}</Link>
                </span>
              )
            })}
            <span className="arrow">{' >'} {prod.nombre}</span>
          </div>
          <div className="title-content">
            <div className="tags-group">
              <div className="tag brand">
                <Link to={`/marca/${prod.marca_id}-${convertStringToLink(prod.marca_nombre)}`}>{prod.marca_nombre}</Link>
              </div>
              <div className="tag sku">SKU: {prod.sku}</div>
              {(prod.variaciones.length === 0 && prod.stock === 0) 
                ? <div className="tag no-stock">Sin Stock</div>
                : <div className="tag in-stock">En Stock</div>
              }
            </div>

            <div className="title">{prod.nombre}</div>
            {isAuthenticated &&
              <div className="price-content">
                {
                  prod.descuento > 0 
                  ? <>
                      <div className="origin-price">$ {formatCurrency(!user.disc_visib ? prod.precio * (1-user.discount/100) : prod.precio)}</div>
                      <div className="price">
                        <span className="sign">$</span>{formatCurrency(prod.precio * (1-user.discount/100) * (1-prod.descuento/100))}
                        <div className="iva">+ iva</div>
                      <div className="discount">{user.disc_visib ? Number((1-((1-user.discount/100) * (1-prod.descuento/100)))*100).toFixed(1): prod.descuento}% off</div>
                    </div></> 
                  : <>
                    {user.discount > 0 && user.disc_visib 
                      ? <div className="origin-price">$ {formatCurrency(prod.precio)}</div>
                      : null
                    }
                    <div className="price">$ {
                      formatCurrency(prod.precio * (1-user.discount/100))}
                      <div className="iva">+ iva</div>
                      {user.discount > 0 && user.disc_visib 
                        ? <div className="discount">{user.discount}% OFF</div>
                        : null
                      }
                    </div>
                    </>
                }
              </div>
            }
            <div className="package-conent">
              {prod.embalaje_uno 
                ? <div><Box /> Cant. x {prod.nombre_embalaje_uno}: {prod.cant_embalaje_uno}</div>
                : null
              }
              {prod.embalaje_dos 
                ? <div><Box /> Cant. x {prod.nombre_embalaje_dos}: {prod.cant_embalaje_dos}</div>
                : null
              }
            </div>
          </div>
        </div>
        <div className="description-content">
            <div className="text" dangerouslySetInnerHTML={{ __html: prod.descripcion }}>
            </div>
          </div>
          {isAuthenticated && 
            <div className="textField">
              <div className="label">Observaciones</div>
              <textarea className="type-" value={observations} placeholder="Detalle aquí las observaciones de su pedido" name="observaciones" id="observaciones" cols="30" rows="3" 
              onChange={(e)=>{setProductData((prev) => ({
                ...prev,
                observaciones: e.target.value
              }))
              setObservations(e.target.value)
              }}></textarea>
            </div>
          }
          <div className="footer">
            {isAuthenticated
              ? <>
                {prod.variaciones.length > 0 &&
                  <>
                    <div className="catalog-product-content">
                      <div className="title-header">
                        <div className="title-text-content">
                          <div className="title-text">Arme su pedido</div>
                        </div>
                        <div className="title-border-rounded"></div>
                      </div>
                      <div className="catalog-table">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>{prod.nombre_variacion}</th>
                              <th>Precio</th>
                              <th>Cant.</th>
                              <th>Subtotal</th>
                              <th>En Carrito</th>
                            </tr>
                          </thead>
                          <tbody>
                            {productData.variaciones.map((item,i) => {
                              return (
                                <tr key={`variacion_${item.nombre}_${i}`}>
                                  <td align="left"><span className="tag">{item.nombre}</span></td>
                                  <td align="right">{
                                    item.descuento > 0
                                    ?<>{user && !user.disc_visib 
                                        ?<>$ {formatCurrency(item.precio * (1-item.descuento/100) )}</>
                                        :<>$ {formatCurrency(item.precio * (1-item.descuento/100)* (1-user.discount/100))}</>
                                      }
                                      <br /><small><del>
                                      $ {formatCurrency(item.precio)}</del></small></>
                                    :<>$ {formatCurrency(item.precio)}</>
                                  }</td>
                                  <td align="center">
                                    {cartSelected 
                                    ? <div className="input-container">
                                      <button className="control-btn left" disabled={item.cantidad === '' || item.cantidad === 0 || item.cantidad <= productData.minimo_compra} onClick={() => {handleDecrement(i)}}>-</button>
                                        <input
                                          type="number"
                                          className="input-number"
                                          value={item.cantidad}
                                          onFocus={()=>{handleFocus(i)}}
                                          onChange={(e)=>{handleChange(i,e.target.value)}}
                                          onBlur={(e)=>{handleBlur(i,e.target.value)}}
                                        />
                                      <button className="control-btn rigth" onClick={()=>{handleIncrement(i)}}>+</button>
                                    </div>
                                    : null}
                                  </td>
                                  <td align="right">$ {formatCurrency(item.subtotal)}</td>
                                  <td align="center">{item.inCart}</td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </>
                }
                {cartSelected
                  ?<>
                    <div className="subtotal"> 
                      Subtotal:
                      <div className="price-content">
                        <span className="sign">$</span>
                        {formatCurrency(productData.subtotal)}
                        <div className="iva">+ iva</div>
                      </div>
                    </div>
                    {prod.variaciones.length > 0
                      ? <>
                          <div className="action-content">
                            <div className="action-container variations">
                              <div className="btn-content">
                                <ButtonAddToCart product={productData} onVisible={onVisible} onMessage={onMessage} setVariantAlert={setVariantAlert} backToPre={true}/>
                                <Button variant="secondary" onClick={handleBuyNow}>Terminar compra</Button>
                              </div>
                            </div>
                            <div className="btn-content">
                              <Button  onClick={handleKeepShopping} className="follow">
                                <ArrowLeft />
                                <span>Volver y seguir comprando</span>
                              </Button>
                            </div>
                          </div>
                        </>
                      :<>
                        {productData.inCart > 0 && <div>Tiene {productData.inCart} en el carrito</div>}
                        <div className="action-content">
                          <ButtonAddToCart product={productData} updateProduct={hundleUpdateProduct} onChangeTotal={totalChanged} onVisible={onVisible} onMessage={onMessage} backToPre={true}/>
                          <div className="btn-content">
                            <Button  onClick={handleKeepShopping} className="follow">
                              <ArrowLeft />
                              <span>Volver y seguir comprando</span>
                            </Button>
                            <Button variant="secondary" onClick={handleBuyNow}>Terminar compra</Button>
                          </div>
                        </div>
                      </>
                    }
                  </>
                : null
                }
              </>
              : <div className="btn-content">
                  <Button  onClick={()=>{navigate("/login");}}>Iniciar Sesión</Button>
                  <Button variant="secondary" onClick={()=>{navigate("/registro");}}>Registrate</Button>
                </div>
            }
            {isAuthenticated &&
              <div className="updated">
                <Clock />
                Actualizado el {prod.actualizado}
              </div>
            }
          </div>
      </div>
    </div>
  );
}
